import * as actionTypes from '../constants/actionTypes';
export default function reducer(
    state={search: {
        content: [],
        search_string: ""
    }, app_id: 0, isSearchCleared: false, isSearchPending: false}, action) {

    switch (action.type) {
        case actionTypes.RECEIVE_SEARCH_ITEMS: {
            return {
                ...state, 
                search: {
                    ...state.search,
                    content: action.payload.content
                }, 
                app_id: action.app_id, 
                isSearchPending: false
            }
        }
        case actionTypes.CLEAR_SEARCH: {
            return {
                ...state,
                search: {
                    content: [],
                    search_string: "",
                },
                isSearchCleared: true
            }
        }
        case actionTypes.TEXT_SEARCH: {
            return {
                ...state,
                search: {
                    ...state.search,
                    search_string: action.payload.string,
                },
                isSearchCleared: false,
                isSearchPending: true
            }
        }
    }

    return state
}